import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import I18n from 'i18n-react';

import './PointsPerPassengerList.css';

const propTypes = {
  isDepartureFlight: PropTypes.bool,
  origin: PropTypes.string.isRequired,
  destination: PropTypes.string.isRequired,
  passengers: PropTypes.arrayOf(
    PropTypes.shape({
      completeName: PropTypes.string.isRequired,
      points: PropTypes.number.isRequired
    })
  ).isRequired
};

class PointsPerPassengerList extends React.Component {
  constructor(props) {
    super(props);

    let subtotal = 0;
    this.props.passengers.map(passenger => (subtotal += passenger.points));

    this.state = {
      subtotalPoints: subtotal
    };
  }

  getPointsFormatted(value) {
    const pattern = /\B(?=(\d{3})+(?!\d))/g;
    return value.toString().replace(pattern, '.');
  }

  renderPassenger(passenger, index, componentId) {
    return (
      <Row className="PointsPerPassengerList__passenger-line" key={`passenger-${index}`}>
        <Col id={componentId + '-passenger-' + index + '-name'} xs={6} className="leftAlign">
          <span>{passenger.completeName}</span>
        </Col>
        <Col id={componentId + '-passenger-' + index + '-points'} xs={6} className="rightAlign">
          <span>
            {I18n.translate('components.pointsPerPassengerList.points', {
              number: this.getPointsFormatted(passenger.points)
            })}
          </span>
        </Col>
      </Row>
    );
  }

  render() {
    let directionFlightI18n = this.props.isDepartureFlight
      ? I18n.translate('components.pointsPerPassengerList.direction.departure')
      : I18n.translate('components.pointsPerPassengerList.direction.return');

    let componentId =
      'PointsPerPassengerList-' + (this.props.isDepartureFlight ? 'departure' : 'return');

    return (
      <div id={componentId} className="PointsPerPassengerList">
        <div className="PointsPerPassengerList__title">
          <Row>
            <Col xs={12}>
              <span>
                {I18n.translate('components.pointsPerPassengerList.title', {
                  direction: directionFlightI18n
                })}
              </span>
            </Col>
          </Row>
        </div>
        <div>
          <Row>
            <Col xs={6} className="PointsPerPassengerList__route">
              <div id={componentId + '-origin'}>
                <span>{this.props.origin}</span>
              </div>
              <div className="Rectangle-path">
                <span />
              </div>
              <div id={componentId + '-destination'}>
                <span>{this.props.destination}</span>
              </div>
            </Col>
          </Row>
        </div>
        <div className="PointsPerPassengerList__passenger">
          {this.props.passengers.map((passenger, index) =>
            this.renderPassenger(passenger, index, componentId)
          )}
          <div className="PointsPerPassengerList__divider" />
        </div>
        <div className="PointsPerPassengerList__subtotal">
          <Row>
            <Col xs={6} className="leftAlign">
              <span>{I18n.translate('components.pointsPerPassengerList.subtotal')}</span>
            </Col>
            <Col id={componentId + '-subtotal'} xs={6} className="rightAlign">
              <span>
                {I18n.translate('components.pointsPerPassengerList.points', {
                  number: this.getPointsFormatted(this.state.subtotalPoints)
                })}
              </span>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

PointsPerPassengerList.propTypes = propTypes;

export default PointsPerPassengerList;



// WEBPACK FOOTER //
// ./src/components/bookingResume/pointsPerPassengerList/PointsPerPassengerList.jsx